export const stringsKey = "NextActionSelection";
export const englishStrings = {
	nextActionLabel: "Next Action",
	nextActionErrorMessage: "The next action field is required.",
};
